import styled from 'styled-components'

import { theme } from 'styles/theme'

const { borderWidths, colors, media, radii, space } = theme

export const IdealCredit = styled.section`
  position: relative;
  width: 100%;
  overflow: hidden;
  background-color: #00203c;
`

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-areas:
    'intro'
    'flask'
    'results';
  gap: ${space['spacing-xl']};
  padding: ${space['spacing-xl']} 8.5rem ${space['spacing-xxl']};

  @media (${media.phone}) {
    padding: ${space['spacing-xl']} ${space['spacing-md']} ${space['spacing-lg']};
  }

  @media (${media.desktop}) {
    grid-template:
      'flask .' 1fr
      'flask intro' auto
      'flask results' auto
      'flask .' 1fr
      / 45% 55%;
    gap: ${space['spacing-md']} ${space['spacing-ultra']};
    align-items: center;
  }
`

export const FlaskColumn = styled.div`
  grid-area: flask;
  width: 100%;
`

export const Intro = styled.div`
  grid-area: intro;
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-md']};
  width: 100%;

  @media (${media.desktop}) {
    max-width: 36rem;
  }
`

export const Results = styled.div`
  grid-area: results;
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (${media.desktop}) {
    max-width: 36rem;
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-sm']};
`

export const EstimateBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-xxs']};
  align-self: flex-start;
  margin-top: ${space['spacing-xs']};
  padding: ${space['spacing-sm']} ${space['spacing-md']};
  border: ${borderWidths['border-stroke-micro']} solid ${colors['blue-border-strong-hover']};
  border-radius: ${radii['corner-radius-md']};

  /* On mobile the estimate moves inside the flask water (S.WaterEstimate). */
  @media (${media.phone}) {
    display: none;
  }
`

export const CtaWrapper = styled.div`
  align-self: flex-start;
  margin-top: ${space['spacing-lg']};

  @media (${media.phone}) {
    align-self: center;
    margin-top: ${space['spacing-nano']};
  }

  button.ds-button {
    padding: 0 ${space['spacing-xl']};
    gap: ${space['spacing-xxs']};
    background-color: ${colors['cashme-magenta']};
    border-radius: ${radii['corner-radius-pill']};

    &:hover {
      background-color: ${colors['cashme-magenta-alt']};
    }
  }
`
